"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _CampaignsAPI = require("./CampaignsAPI");

(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.CAMPAIGNS,
  fetch: _CampaignsAPI.fetch
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.CAMPAIGNS,
  idIsValid: function idIsValid(id) {
    return typeof id === 'string';
  }
}).defineName('CampaignsStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;